var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout",
    { attrs: { view: "hHh Lpr lFf" } },
    [
      _c(
        "q-layout-header",
        { staticClass: "no-shadow", attrs: { id: "main-header" } },
        [
          _c(
            "q-toolbar",
            { attrs: { color: "white", "text-color": "#727272" } },
            [
              _c("div", { attrs: { id: "main-header-left" } }, [
                _c(
                  "div",
                  {
                    attrs: { id: "menu-icon-holder" },
                    on: {
                      click: function($event) {
                        _vm.toggleNavDrawer()
                      }
                    }
                  },
                  [_c("span", { attrs: { id: "menu-icon" } })]
                ),
                _c("div", { staticClass: "logo text-center" }, [
                  _c("span", [_vm._v("cascades")])
                ])
              ]),
              _c(
                "q-toolbar-title",
                { staticClass: "text-center" },
                [
                  _c("q-icon", { attrs: { name: "fa fa-user" } }),
                  _vm._v("\n        " + _vm._s(this.$route.name) + "\n      ")
                ],
                1
              ),
              _c("div", {
                staticClass: "hidden",
                attrs: { id: "quick-search" }
              }),
              _c("notification-center", { ref: "notificationCenter" }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "ripple",
                      rawName: "v-ripple.mat",
                      modifiers: { mat: true }
                    }
                  ],
                  staticClass: "label green round action"
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.userInitials))]),
                  _c(
                    "q-popover",
                    [
                      _c(
                        "q-list",
                        [
                          _c(
                            "q-item",
                            {
                              directives: [
                                {
                                  name: "close-overlay",
                                  rawName: "v-close-overlay"
                                }
                              ],
                              attrs: { link: "" },
                              nativeOn: {
                                click: function($event) {
                                  _vm.selectUser(_vm.user)
                                }
                              }
                            },
                            [
                              _c("q-item-side", {
                                attrs: {
                                  icon: "person",
                                  "text-color": "secondary"
                                }
                              }),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(" View Profile")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-item",
                            {
                              directives: [
                                {
                                  name: "close-overlay",
                                  rawName: "v-close-overlay"
                                }
                              ],
                              attrs: { link: "" },
                              nativeOn: {
                                click: function($event) {
                                  _vm.logoutUser()
                                }
                              }
                            },
                            [
                              _c("q-item-side", {
                                attrs: {
                                  icon: "power_settings_new",
                                  "text-color": "secondary"
                                }
                              }),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(" Logout")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-layout-drawer",
        { attrs: { id: "left-menu", side: "left", value: _vm.navDrawer } },
        [
          _c(
            "ul",
            _vm._l(_vm.navigationItems, function(item, i) {
              return _vm.permission(item.$p, null, item)
                ? _c(
                    "li",
                    {
                      key: i,
                      class: {
                        "no-expand": item.expand === false,
                        "red-circle":
                          item.title == "Orders" && _vm.orderNotification
                      }
                    },
                    [
                      item.route
                        ? _c(
                            "router-link",
                            { attrs: { to: item.route } },
                            [
                              item.icon
                                ? _c("q-icon", { attrs: { name: item.icon } })
                                : _vm._e(),
                              _c("span", {
                                domProps: { textContent: _vm._s(item.title) }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !item.route
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                }
                              }
                            },
                            [
                              item.icon
                                ? _c("q-icon", { attrs: { name: item.icon } })
                                : _vm._e(),
                              _c("span", {
                                domProps: { textContent: _vm._s(item.title) }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.children && item.children.length
                        ? _c(
                            "ul",
                            _vm._l(item.children, function(child, c) {
                              return _vm.permission(child.$p, true)
                                ? _c(
                                    "li",
                                    { key: c },
                                    [
                                      child.route
                                        ? _c(
                                            "router-link",
                                            { attrs: { to: child.route } },
                                            [
                                              child.icon
                                                ? _c("q-icon", {
                                                    attrs: { name: child.icon }
                                                  })
                                                : _vm._e(),
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    child.title
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      !child.route && child.modal
                                        ? _c(
                                            "a",
                                            {
                                              attrs: { href: "#" },
                                              on: {
                                                click: [
                                                  function($event) {
                                                    $event.preventDefault()
                                                  },
                                                  function($event) {
                                                    _vm.openModal(child.modal)
                                                  }
                                                ]
                                              }
                                            },
                                            [
                                              child.icon
                                                ? _c("q-icon", {
                                                    attrs: { name: child.icon }
                                                  })
                                                : _vm._e(),
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    child.title
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            })
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            })
          )
        ]
      ),
      _c("q-page-container", [_c("router-view")], 1),
      _vm.certificatesModal ? _c("certificates-modal") : _vm._e(),
      _vm.studentCompletionModal ? _c("student-completion") : _vm._e(),
      _vm.recruiterReferralModal ? _c("recruiter-referral") : _vm._e(),
      _vm.accountingReportModal ? _c("accounting-report") : _vm._e(),
      _vm.affiliateScheduleModal ? _c("affiliate-schedule") : _vm._e(),
      _vm.unscheduledClassesModal ? _c("unscheduled-classes-report") : _vm._e(),
      _vm.addressValidationModal ? _c("address-validation-report") : _vm._e(),
      _vm.processPaymentModalOpen ? _c("payment-modal") : _vm._e(),
      _vm.detailsModalOpenState ? _c("order-details-modal") : _vm._e(),
      _vm.userDetailsOpen ? _c("user-details-modal") : _vm._e(),
      _vm.userWizardOpen ? _c("user-wizard-modal") : _vm._e(),
      _vm.classesModalState ? _c("class-details-modal") : _vm._e(),
      _vm.scheduleUploadOpen ? _c("schedule-upload-modal") : _vm._e(),
      _vm.jobModalOpen ? _c("job-modal") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }